import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { Input } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import SideBar from "../../components/SideBar";
import { addItemApi } from "../../api/items";

const REQUIRED_FIELDS = [
  ["numeroArticle", "Veuillez entrer le numéro d'article"],
  ["desination", "Veuillez entrer la désignation"],
  ["responsable", "Veuillez entrer le responsable de véhicule"],
  ["quantite", "Veuillez entrer la quantité"],
  ["price", "Veuillez entrer le prix unitaire"],
  ["sumOfPrice", "Veuillez entrer le prix total de la commande"],
  ["prestataire", "Veuillez entrer le prestataire"],
  ["ice", "Veuillez entrer l'ICE"],
];

function NewItemsManagement() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    numeroArticle: "",
    desination: "",
    responsable: "",
    quantite: "",
    price: "",
    sumOfPrice: "",
    prestataire: "",
    ice: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (key) => (e) => {
    setForm({ ...form, [key]: e.target.value });
  };

  const handleSubmit = async () => {
    for (const [key, message] of REQUIRED_FIELDS) {
      if (!String(form[key]).trim()) {
        return Swal.fire({ title: "Champ manquant", text: message, icon: "error" });
      }
    }

    if (isNaN(Number(form.quantite)) || isNaN(Number(form.price)) || isNaN(Number(form.sumOfPrice))) {
      return Swal.fire({
        title: "Valeur invalide",
        text: "Quantité, prix unitaire et prix total doivent être des nombres.",
        icon: "error",
      });
    }

    setIsSubmitting(true);

    try {
      const response = await addItemApi(
        form.numeroArticle,
        form.desination,
        form.responsable,
        Number(form.quantite),
        Number(form.price),
        Number(form.sumOfPrice),
        form.prestataire,
        form.ice
      );

      if (!response) {
        return Swal.fire({ title: "Erreur!", text: "Erreur serveur", icon: "error" });
      }

      await Swal.fire({ title: "Article ajouté", text: "", icon: "success" });
      navigate("/admin/GestionDesPieces");
    }
    catch (err) {
      Swal.fire({
        title: "Erreur!",
        text: err?.response?.data?.error || "Une erreur est survenue",
        icon: "error",
      });
    }
    finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="NewItemsManagementSection">
      <Row>
        <Col md="2" className="p-0">
          <SideBar />
        </Col>
        <Col md="10" className="p-0">
          <div className="contents">
            <div className="bodyInput">
              <div className="left">
                <h3>Information sur l'article commandé</h3>
                <div className="left_side_input">
                  <Input placeholder="N° Article" value={form.numeroArticle} onChange={handleChange("numeroArticle")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="Désignation" value={form.desination} onChange={handleChange("desination")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="Responsable de véhicule" value={form.responsable} onChange={handleChange("responsable")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="Quantité" value={form.quantite} onChange={handleChange("quantite")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="Prix unitaire" value={form.price} onChange={handleChange("price")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="Prix total de la commande" value={form.sumOfPrice} onChange={handleChange("sumOfPrice")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="Prestataire" value={form.prestataire} onChange={handleChange("prestataire")} />
                </div>
                <div className="left_side_input">
                  <Input placeholder="ICE" value={form.ice} onChange={handleChange("ice")} />
                </div>
              </div>
            </div>

            <div className="submitBtn">
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                {isSubmitting ? "Enregistrement…" : "Valider"}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default NewItemsManagement;
